// Actions
import {
  SET_LANGUAGE,
  SET_LOADING_LANGUAGE,
  SET_AVAILABLE_LANGUAGES,
  RESET_LANGUAGE,
} from '../actions/ui/language';

interface LanguageState {
  currentLanguage: string;
  availableLanguages: string[];
  isLoading: boolean;
}

export const initialLanguageState: LanguageState = {
  currentLanguage: 'es', // Español como idioma por defecto
  availableLanguages: ['ca', 'es', 'en'],
  isLoading: false,
};

type ActionType = {
  type: string;
  payload?: any;
};

export default function language(
  state = initialLanguageState,
  { type, payload }: ActionType
): LanguageState {
  switch (type) {
    case SET_LANGUAGE:
      return {
        ...state,
        currentLanguage: payload,
      };
    case SET_LOADING_LANGUAGE:
      return {
        ...state,
        isLoading: payload,
      };
    case SET_AVAILABLE_LANGUAGES:
      return {
        ...state,
        availableLanguages: payload,
      };
    case RESET_LANGUAGE:
      return {
        ...initialLanguageState,
      };
    default:
      return state;
  }
}
